import { type FC, type ComponentProps } from "react";
import { Grid } from "@root/shared/components/Grid";
import { Icon } from "@root/shared/components/Icon";
import { TextLink } from "@root/shared/components/TextLink";
import { NoButtonWorkCassette } from "@root/userFrontend/components/NoButtonWorkCassette";
import * as styles from "./style.css";

type Props = {
  title: string;
  description: string;
  gaActionPrefix: string;
  works: ComponentProps<typeof NoButtonWorkCassette>[];
  linkPath: string;
};

export const RecommendWorks: FC<Props> = ({
  title,
  description,
  gaActionPrefix,
  works,
  linkPath,
}) => {
  return (
    <section className={styles.outer} data-ga-action={`${gaActionPrefix}_content`}>
      <div className={styles.container}>
        <h3 className={styles.heading}>{title}</h3>
        <p className={styles.description}>
          <img
            src="/images/user_frontend/global/icon/icn_tag.svg"
            alt=""
            loading="lazy"
            width="15"
            height="16"
          />
          {description}
        </p>
        <Grid columns={1} gapY={16} className={styles.gridOuter}>
          {works.map((work) => (
            <NoButtonWorkCassette key={work.url} {...work} gaAction={`${gaActionPrefix}_job`} />
          ))}
          <div className={styles.textLinkOuter}>
            <TextLink
              href={linkPath}
              icon={<Icon name="target-blank" />}
              isBold
              className={styles.textLink}
              target="_blank"
              data-ga-action={`${gaActionPrefix}_search`}
            >
              この条件で探してみる
            </TextLink>
          </div>
        </Grid>
      </div>
    </section>
  );
};
